import { Building2, Cloud, Landmark, Layers, Package, Server, Users } from "lucide-react";
import type { ScopeNode, ScopeTypeMeta } from "../types/scope";


export const SCOPE_TYPES: Record<ScopeNode["type"], ScopeTypeMeta> = {
  group: { label: "Group", icon: Building2, chipClassName: "bg-sky-500/15 text-sky-600 dark:text-sky-400", order: 10 },
  org: { label: "Organization", icon: Landmark, chipClassName: "bg-violet-500/15 text-violet-600 dark:text-violet-400", order: 20 },
  department: { label: "Department", icon: Users, chipClassName: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400", order: 30 },
  division: { label: "Division", icon: Layers, chipClassName: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400", order: 31 },
  application: { label: "Application", icon: Package, chipClassName: "bg-amber-500/20 text-amber-700 dark:text-amber-400", order: 40 },
  asset: { label: "Asset", icon: Server, chipClassName: "bg-muted text-muted-foreground", order: 50 },
  cloud: { label: "Cloud Account", icon: Cloud, chipClassName: "bg-sky-500/10 text-sky-600 dark:text-sky-400", order: 41 },
};

const pluralize = (n: number, singular: string): string => (n === 1 ? `${n} ${singular}` : `${n} ${singular}s`);

/** Every node id in the selection, grouped by type (used by both the
 * trigger summary and the "shallowest selected type" label below). */
function groupSelectionByType(nodesById: Map<string, ScopeNode>, selectedIds: string[]): Map<ScopeNode["type"], number> {
  const byType = new Map<ScopeNode["type"], number>();
  for (const id of selectedIds) {
    const node = nodesById.get(id);
    if (!node) continue;
    byType.set(node.type, (byType.get(node.type) ?? 0) + 1);
  }
  return byType;
}
